<script>
import Layout from '@layouts/main'
import BarChart from '@components/BarChart'
import { authComputed, dashboardMethods } from '@state/helpers'

export default {
  metaInfo: {
    title: 'Inbox',
    meta: [{ name: 'description', content: 'Inbox' }],
  },
  components: { Layout, BarChart },
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      codingMetricsResult: {
        invalidCptCodes: {},
        invalidRevCodes: {},
        invalidModifiers: {},
      },
      requestCountsResult: {
        lessThanThree: 0,
        threeToFive: 0,
        fiveOrMore: 0,
      },
    }
  },
  computed: {
    ...authComputed,
  },
  created() {
    this.updateCodingMetrics()

    this.pendingRequestCounts()
      .then(result => {
        this.requestCountsResult = result
      })
      .catch(_ => {})
  },
  methods: {
    ...dashboardMethods,
    updateCodingMetrics() {
      if (!this.currentUser.currentFacilityId) {
        return
      }

      this.codingMetrics({ facilityId: this.currentUser.currentFacilityId })
        .then(result => {
          this.codingMetricsResult = result
        })
        .catch(_ => {})
    },
  },
}
</script>

<template>
  <Layout>
    <v-container fluid grid-list-md ma-0>
      <h3>Dashboard</h3>

      <v-layout row wrap>
        <!-- Card A -->
        <v-flex md8>
          <v-card>
            <v-card-title primary-title>
              <div class="requestChart">
                <h3>
                  Requests Created By Day
                  <img src="/assets/icon-question.svg" width="12px" alt="?" />
                </h3>
                <p>
                  Date range: In the last 30 days | Frequency: Daily
                  <base-link>Report settings</base-link>
                </p>
                <BarChart x-key="key" y-key="value" :data="chartData" />
              </div>
            </v-card-title>
          </v-card>
        </v-flex>

        <!-- Card B -->
        <v-flex md4>
          <v-card>
            <v-card-title primary-title>
              <h3>
                Pending Requests
                <img src="/assets/icon-question.svg" width="12px" alt="?" />
              </h3>

              <div class="cardContents">
                <!-- Days since -->
                <v-layout column>
                  <div class="contentBox outline mt-2">
                    <img src="/assets/icon-time-cyan.svg" alt="Time" />
                    <div class="d-flex-column ml-3">
                      <div class="h3 mb-1">
                        {{ requestCountsResult.lessThanThree }}
                      </div>
                      <div>LESS THAN 3 DAYS</div>
                    </div>
                  </div>
                  <div class="contentBox outline mt-2">
                    <img src="/assets/icon-time-gold.svg" alt="Time" />
                    <div class="d-flex-column ml-3">
                      <div class="h3 mb-1">
                        {{ requestCountsResult.threeToFive }}
                      </div>
                      <div>3 - 5 DAYS</div>
                    </div>
                  </div>
                  <div class="contentBox outline mt-2">
                    <img src="/assets/icon-time-red.svg" alt="Time" />
                    <div class="d-flex-column ml-3">
                      <div class="h3 mb-1">
                        {{ requestCountsResult.fiveOrMore }}
                      </div>
                      <div>5 DAYS OR GREATER</div>
                    </div>
                  </div>
                </v-layout>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>

        <!-- Card C -->
        <v-flex xs12 class="mt-3">
          <v-card>
            <v-card-title primary-title>
              <div class="cardContents">
                <!-- Header -->
                <v-layout row align-center space-between>
                  <v-flex md6 lg8>
                    <h3>
                      Number of Invalid Coding
                      <img
                        src="/assets/icon-question.svg"
                        width="12px"
                        alt="?"
                      />
                    </h3>
                  </v-flex>
                  <v-flex md3 lg4 text-right>For Dataset: Current</v-flex>
                  <v-flex md3 lg3 text-right>
                    Coding Data: Q4 2019
                  </v-flex>
                </v-layout>

                <!-- Metrics -->
                <v-layout row>
                  <v-flex md4>
                    <div class="contentBox text-white cyan">
                      <img src="/assets/icon-shield.png" alt="Shield" />
                      <span class="h3 mb-0 mx-3">
                        {{
                          Object.keys(codingMetricsResult.invalidCptCodes)
                            .length
                        }}
                      </span>
                      <span>CPT</span>
                    </div>
                  </v-flex>
                  <v-flex md4 mx-4>
                    <div class="contentBox text-white orange">
                      <img src="/assets/icon-revenue.png" alt="Revenue" />
                      <span class="h3 mb-0 mx-3">
                        {{
                          Object.keys(codingMetricsResult.invalidRevCodes)
                            .length
                        }}
                      </span>
                      <span>REVENUE CODE</span>
                    </div>
                  </v-flex>
                  <v-flex md4>
                    <div class="contentBox text-white blue">
                      <img src="/assets/icon-star.svg" alt="Star" />
                      <span class="h3 mb-0 mx-3">
                        {{
                          Object.keys(codingMetricsResult.invalidModifiers)
                            .length
                        }}
                      </span>
                      <span>MODIFIER</span>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </Layout>
</template>

<style lang="scss">
@import '@design';

// TODO: formatting [selector-class-pattern]
.cardContents {
  width: 100%;
}

.contentBox {
  display: flex;
  align-items: center;
  height: 80px;
  padding: 0 20px;
  border-radius: 4px;
  &.outline {
    border: 1px solid gainsboro;
  }
}

.requestChart {
  width: 100%;
}
</style>
